export default "__VITE_ASSET__Dfl5i0TY__"